import {
  DELAY_AFTER_PURCHASE_KEY,
  HAS_DELAY_AFTER_PURCHASE_KEY,
} from '@esentai/core/features/campaigns/purchaseResult/consts/keys';
import {
  Checkbox,
  FormControlLabel,
  Input,
  InputAdornment,
  Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import FieldRow from '@/components/FieldRow';
import pluralize from '@/utils/pluralize';

import { CanEdit } from '../../CanEdit';

const secondsLabel = seconds =>
  pluralize(seconds, {
    one: 'секунда',
    few: 'секунды',
    many: 'секунд',
  });

class DelayForm extends PureComponent {
  static propTypes = {
    delayAfterPurchase: PropTypes.any.isRequired,
    hasDelayAfterPurchase: PropTypes.bool.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    Field: PropTypes.func.isRequired,
  };

  setHasDelay = event => {
    const { checked } = event.target;
    const { setFieldValue } = this.props;

    setFieldValue(HAS_DELAY_AFTER_PURCHASE_KEY, checked);
  };

  render() {
    const {
      classes,
      delayAfterPurchase,
      hasDelayAfterPurchase,
      Field,
    } = this.props;

    return (
      <FieldRow
        label="Задержка"
        subLabel="Задержка активации после покупки"
        sudDesc="Задержка выставляется в секундах. 1 минута = 60 сек. 1 час = 3600 сек. 1 день = 86400 сек. Обратите внимание, что отправка пуш-уведомление может происходить также с задержкой."
      >
        <CanEdit field={HAS_DELAY_AFTER_PURCHASE_KEY}>
          <FormControlLabel
            label="Установить таймаут активации кампании"
            control={
              <Checkbox
                checked={hasDelayAfterPurchase}
                onChange={this.setHasDelay}
              />
            }
          />
        </CanEdit>

        {hasDelayAfterPurchase && (
          <CanEdit field={HAS_DELAY_AFTER_PURCHASE_KEY}>
            <Field
              Target={Input}
              name={DELAY_AFTER_PURCHASE_KEY}
              label="Размер таймаута"
              endAdornment={
                <InputAdornment position="end">
                  <Typography className={classes.measure}>
                    {secondsLabel(delayAfterPurchase)}
                  </Typography>
                </InputAdornment>
              }
              type="number"
              className={classes.delayInput}
            />
          </CanEdit>
        )}
      </FieldRow>
    );
  }
}

export default DelayForm;
